export const dataSource = [
  {
    activePecent: 13.57,
    activeUser: 5183,
    arpu: 0.09,
    cresCost: 0.57,
    date: 20200919,
    geo: "中国",
    campaign: "",
    incomeTotalUSD: 468.22,
    mediaSource: "总计",
    orgIncre: 147,
    orgPercent: 62.55,
    popCost: 0.92,
    popTotalUSD: 217.31,
    arpuPerPopuCost: 0.356,
    popuIncre: 235,
    reten1: 167,
    reten3: 89,
    reten7: 0,
    reten14: 0,
    reten30: 0,
    retenRate1: 43.72,
    retenRate3: 23.3,
    roiTotal: 204.95,
    toDayROI: 215.46,
    totalIncre: 382,
    totalInstalls1: 382,
    totalInstalls3: 382,
    totalInstalls7: 0,
    totalInstalls14: 0,
    totalInstalls30: 0,
  },
  {
    activePecent: 13.57,
    activeUser: 5183,
    arpu: 0.09,
    cresCost: 0.57,
    date: 20200919,
    geo: "中国",
    campaign: "mxixx",
    incomeTotalUSD: 468.22,
    mediaSource: "Facebook Ads",
    orgIncre: 147,
    orgPercent: 62.55,
    popCost: 0.92,
    popTotalUSD: 217.31,
    popuIncre: 235,
    reten1: 167,
    arpuPerPopuCost: 0.356,
    reten3: 89,
    reten7: 0,
    reten14: 0,
    reten30: 0,
    retenRate1: 43.72,
    retenRate3: 23.3,
    roiTotal: 204.95,
    toDayROI: 215.46,
    totalIncre: 382,
    totalInstalls1: 382,
    totalInstalls3: 382,
    totalInstalls7: 0,
    totalInstalls14: 0,
    totalInstalls30: 0,
  },
];
function sortColumn(a, b, key) {
  if (!a[key] && !b[key]) {
    return -1;
  } else if (!a[key] && b[key]) {
    return -1;
  } else if (a[key] && !b[key]) {
    return 1;
  }
  return a[key] - b[key] >= 0 ? 1 : -1;
}
export const column = [
  {
    key: "geo",
    name: "国家或地区",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    key: "mediaSource",
    name: "资源",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    key: "campaign",
    name: "campaign",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "totalIncre",
    name: "总新增",
    sort: false,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
    show: false,
  },
  {
    id: 2,
    key: "popuIncre",
    name: "推广新增",
    sort: false,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
    show: false,
  },
  {
    id: 3,
    key: "orgIncre",
    name: "自然新增",
    sort: false,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
    show: false,
  },
  {
    id: 4,
    key: "orgPercent",
    name: "自然量占比",
    sort: false,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgPercent"),
    show: false,
    tip: "自然新增/总新增",
  },
  {
    id: 5,
    key: "activeUser",
    name: "活跃用户",
    sort: false,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activeUser"),
    show: false,
    copy: false,
  },
  {
    id: 6,
    key: "activePecent",
    name: "活跃增比",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activePecent"),
    show: false,
    tip: "活跃用户/总新增",
  },
  {
    id: 7,
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    show: false,
    tip: "支出总计/总新增",
  },
  {
    id: 8,
    key: "popCost",
    name: "推广单价",
    unit: "$",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popCost"),
    show: false,
    tip: "支出总计/推广新增",
  },
  {
    id: 9,
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    sort: false,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "arpu"),
    show: false,
    tip: "变现收入/活跃用户",
  },
  {
    id: 100,
    key: "arpuPerPopuCost",
    name: "arpu/推广单价",
    unit: "$",
    sort: false,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "arpuPerPopuCost"),
    show: false,
  },
  {
    id: 10,
    key: "estimateValue",
    name: "估算变现价值",
    unit: "$",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateValue"),
    show: false,
    tip: "活跃arpu*预估倍数",
  },
  {
    id: 11,
    key: "increRoi",
    name: "新增ROI",
    percent: "%",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "increRoi"),
    show: false,
    tip: "估算变现价值/新增单价",
  },
  {
    id: 12,
    key: "popuRoi",
    name: "推广ROI",
    percent: "%",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuRoi"),
    show: false,
    tip: "估算变现价值/推广单价",
  },
  {
    id: 13,
    key: "incomeTotalUSD",
    name: "变现收入(美金)",
    unit: "$",
    sort: false,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "incomeTotalUSD"),
    show: false,
    copy: false,
  },
  {
    id: 14,
    key: "popTotalUSD",
    name: "推广总计(美金)",
    unit: "$",
    sort: false,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotalUSD"),
    show: false,
    copy: false,
  },
  {
    id: 15,
    key: "toDayROI",
    name: "当前ROI",
    percent: "%",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "toDayROI"),
    show: false,
    tip: "（所选时间段内维度下的）收入总计/支出总计",
  },
  {
    id: 16,
    key: "roiTotal",
    name: "历史总ROI",
    percent: "%",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "roiTotal"),
    show: false,
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    id: 17,
    key: "estimateTimes",
    name: "365日LT",
    sort: false,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateTimes"),
    tip: "基于7日以上留存预估,与所选时间段无关",
  },
  {
    id: 18,
    key: "payIncome",
    name: "内购收入(美金)",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payIncome"),
    show: true,
    tip: "分成后收入",
  },
  {
    id: 19,
    key: "payPerAdsRate",
    name: "内购收入占比",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payPerAdsRate"),
    show: true,
    tip: "内购收入/（变现收入+内购收入）",
  },
  {
    id: 20,
    key: "avgActivePayIncome",
    name: "活跃人均内购",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "avgActivePayIncome"),
    show: true,
    tip: "内购收入/活跃用户",
  },
  {
    id: 21,
    key: "allTotalIncome",
    name: "收入总计",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "allTotalIncome"),
    show: true,
    tip: "变现收入+内购收入",
  },
  {
    id: 22,
    key: "currentRoi",
    name: "当前变现ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "currentRoi"),
    show: true,
    tip: "变现收入/推广总计",
  },
  {
    id: 23,
    key: "predictPayValue",
    name: "估算内购价值",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictPayValue"),
    show: true,
    tip: "活跃人均内购*预估倍数",
  },
  {
    id: 24,
    key: "predictUserValue",
    name: "估算用户价值",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictUserValue"),
    show: true,
    tip: "估算变现价值+估算内购价值",
  },
  {
    id: 25,
    key: "retenRate1",
    name: "1留",
    sort: false,
    point: 2,
    percent: "%",
    sortMethod: (a, b) => sortColumn(a, b, "retenRate1"),
    show: false,
  },
  {
    id: 26,
    key: "retenRate3",
    name: "3留",
    sort: false,
    point: 2,
    percent: "%",
    sortMethod: (a, b) => sortColumn(a, b, "retenRate3"),
    show: false,
  },
  {
    id: 27,
    key: "retenRate7",
    name: "7留",
    sort: false,
    point: 2,
    percent: "%",
    sortMethod: (a, b) => sortColumn(a, b, "retenRate7"),
    show: false,
  },
  {
    id: 28,
    key: "retenRate14",
    name: "14留",
    sort: false,
    point: 2,
    percent: "%",
    sortMethod: (a, b) => sortColumn(a, b, "retenRate14"),
    show: false,
  },
  {
    id: 29,
    key: "retenRate30",
    name: "30留",
    sort: false,
    point: 2,
    percent: "%",
    sortMethod: (a, b) => sortColumn(a, b, "retenRate30"),
    show: false,
  },
];
